module.exports = require("@foundit/genericdownload/dist/GenericDownload.css");